import {TreeView} from "@mui/lab";
import React, {useEffect} from "react";
import {FolderItem} from "./FolderItem";
import {Box} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {IFileSystemContent} from "./content/FileSystemContent";

const useScriptStyles = makeStyles(theme => ({
    container: {
        flexGrow: 1,
        margin: theme.spacing(1),
        overflowX: "hidden",
        overflowY: "auto",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    } 
}));

export interface IReference {
    fullPath: string
    name: string
}
export interface IFolderBase {
    path: IReference
}
export interface IPendingContents extends IFolderBase {
    pending: boolean
}
export interface IFolderContents extends IFolderBase {
    folders: IFolderBase[]
    files: IReference[]
}
interface IProps {
    content: IFileSystemContent
    onSelected: (selected: string) => void
    path: string
    selected?: string
}
export function FolderContents({content, onSelected, path, selected}: IProps) {
    const classes = useScriptStyles();
    const [expanded, setExpanded] = React.useState<string[]>([]);
    const [selectedFiles, setSelectedFiles] = React.useState<string[]>([]);
    const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
        setExpanded(nodeIds);
    };
    const handleSelect = (event: React.SyntheticEvent, nodeIds: string[]) => {
        setSelectedFiles(nodeIds);
    };

    useEffect(() => {
        if (selected) {
            const path = content.getPath(selected);

            setExpanded(path);
            setSelectedFiles(path.slice(-1));
        }
    }, [content, selected])
    if (! content) return null;
    return (
        <Box className={classes.container}>
            <TreeView expanded={expanded} onNodeToggle={handleToggle} onNodeSelect={handleSelect}
                      selected={selectedFiles}>
                <FolderItem content={content} onSelected={onSelected} path={path}/>
            </TreeView>
        </Box>
    );
}
